import { SortStatus } from '../../components/common/sortButton';
import { ColumnTypes, ExtendedColumnProps } from './column';
import { DateUtils } from 'react-day-picker';

export type TableSort = {
  sorterKey?: string;
  key?: string | number | symbol;
  status: SortStatus;
}

export interface ColumnFields {
  [key: string]: boolean;
}

export type TableFilter = {
  key: string;
  value: string|number|boolean;
}

export type FilterTablePayload = TableFilter;

export type SortTablePayload<T> = {
  column?: ExtendedColumnProps<T>;
  sortStatus?: SortStatus;
}

export function getValueFromPath<T, U>(data: T, field: string | string[], defaultValue?: U): U {
  let path: string[] = [];
  if (!Array.isArray(field)) {
    path = [field as string];
  } else {
    path = field;
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  let dataValue: T | any = data;
  path.forEach((subField) => {
    if (dataValue && subField in dataValue) {
      dataValue = dataValue[subField];
    } else {
      dataValue = defaultValue;
    }
  });
  return dataValue;
}

export function getFilterForColumn<T>(col: ExtendedColumnProps<T>, filters: TableFilter[]):string {
  const filterForColumn = filters.find(tableFilter => tableFilter.key === col.key);
  return filterForColumn ? filterForColumn.value as string : '';
}

export function shouldFilterDataRecord<T>(col: ExtendedColumnProps<T>, filteredValue:string|number|boolean, record: T):boolean {
  const filter = filteredValue as string;
  if (!filteredValue) {
    return true;
  }

  let dataValue = getValueFromPath<T, string>(record, col.dataIndex as string);
  if (col.dataType !== ColumnTypes.Numeric && !dataValue) {
    dataValue = '';
  }
  if (col.mapper) {
    const option = record[col.key as keyof T];
    dataValue = col.mapper(dataValue, option) as string;
  }

  switch (col.dataType) {
  case ColumnTypes.Date:
    const dateSegments = filter.split('-');
    const from = new Date(+dateSegments[0]);
    const to = new Date(+dateSegments[1]);
    return DateUtils.isDayInRange(new Date(dataValue), { from, to });
  case ColumnTypes.Numeric:
    return dataValue.toString() === filteredValue.toString();
  default:
    return dataValue?.toString().toLowerCase().includes(`${filter}`.toLowerCase());
  }
}
